import { render, staticRenderFns } from "./GettingFilesBtns.vue?vue&type=template&id=0b74510b"
import script from "./GettingFilesBtns.vue?vue&type=script&lang=ts"
export * from "./GettingFilesBtns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports